/* Article FAQ — enhancement UX (accordion).
 * Lo SCHEMA FAQPage è generato server-side in Liquid (snippet article-faq-schema),
 * così è leggibile dai crawler AI che non eseguono JS. Qui trasformiamo solo la
 * sezione "Domande frequenti" del corpo articolo in un accordion accessibile.
 * Degrada a nulla se la sezione non esiste.
 */
(function () {
  function normalize(s) {
    return (s || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function enhance(scope) {
    var h2s = scope.querySelectorAll("h2");
    var faqH2 = null;
    for (var i = 0; i < h2s.length; i++) {
      if (normalize(h2s[i].textContent).indexOf("domande frequenti") !== -1) {
        faqH2 = h2s[i];
        break;
      }
    }
    if (!faqH2) return;

    var node = faqH2.nextElementSibling;
    var items = [];
    var current = null;
    while (node && node.tagName !== "H2") {
      var next = node.nextElementSibling;
      if (node.tagName === "H3") {
        current = { q: node.textContent.trim(), answerNodes: [], qEl: node };
        if (current.q) items.push(current);
      } else if (current) {
        current.answerNodes.push(node);
      }
      node = next;
    }
    if (!items.length) return;

    faqH2.classList.add("article-faq__title");
    faqH2.setAttribute("id", "domande-frequenti");

    items.forEach(function (it) {
      var details = document.createElement("details");
      details.className = "article-faq__item";
      var summary = document.createElement("summary");
      summary.className = "article-faq__q";
      summary.textContent = it.q;
      var answer = document.createElement("div");
      answer.className = "article-faq__a rte";
      it.answerNodes.forEach(function (el) { answer.appendChild(el.cloneNode(true)); });
      details.appendChild(summary);
      details.appendChild(answer);
      it.qEl.replaceWith(details);
      it.answerNodes.forEach(function (el) { el.remove(); });
    });
  }

  function init() {
    document.querySelectorAll("[data-faq]").forEach(enhance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
